import { render, staticRenderFns } from "./IndicadorDiferenciaPlazos.vue?vue&type=template&id=27ef10be&"
import script from "./IndicadorDiferenciaPlazos.vue?vue&type=script&lang=js&"
export * from "./IndicadorDiferenciaPlazos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports